const LEGACY_CUG_RATE_RULE_PREFIXES = ['le_standard', 'le_mobile']
const RATE_RULE_FIELD_SEPARATOR = '~'
const RATE_RULE_MIN_FIELD_COUNT = 9
const RATE_RULE_RATE_TYPE_INDEX = 4
const CUG_RATE_TYPE = 'C'

// Keep this isolated so the legacy URL/cookie fallback can be removed cleanly
// after old GHA rule IDs have aged out.
function isLegacyCugRateRule(ruleId: string): boolean {
  const normalizedRuleId = ruleId.toLowerCase()
  return LEGACY_CUG_RATE_RULE_PREFIXES.some(prefix => normalizedRuleId.startsWith(prefix))
}

// Compact GHA rule IDs keep field order stable and may append fields over time.
// rate_type is the fifth field: C = CUG, B = B2C.
function isCompactCugRateRule(ruleId: string): boolean {
  const fields = ruleId.split(RATE_RULE_FIELD_SEPARATOR)
  if (fields.length < RATE_RULE_MIN_FIELD_COUNT) return false

  return fields[RATE_RULE_RATE_TYPE_INDEX]?.toUpperCase() === CUG_RATE_TYPE
}

export function isEligibleMetasearchCugRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  if (isCompactCugRateRule(ruleId)) return true

  return isLegacyCugRateRule(ruleId)
}
